/* Compatibility shim reproducing the prototype's router API on top of
   react-router-dom v6, so ported pages can keep using useRoute()/navigate()/Link.
   Uses clean URLs (no leading "#"). */
import { useLocation, useSearchParams, Link as RRLink } from "react-router-dom";

/* useRoute() → { path, query, raw } */
export function useRoute() {
  const loc = useLocation();
  const [sp] = useSearchParams();
  const query = {};
  sp.forEach((v, k) => {
    query[k] = v;
  });
  return { path: loc.pathname, query, raw: loc.pathname + loc.search };
}

/* Module-level navigator, registered by <NavigatorBridge/> mounted in App.
   Lets non-component code (form submit handlers) call navigate() imperatively. */
let _navigator = null;
export function setNavigator(fn) {
  _navigator = fn;
}

export function navigate(path, opts = {}) {
  const { replace = false, scroll = true } = opts;
  const to = path.startsWith("/") ? path : "/" + path;
  if (_navigator) {
    _navigator(to, { replace });
  } else {
    // Fallback before the bridge mounts.
    window.location.assign(to);
  }
  if (scroll) {
    requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: "instant" }));
  }
}

/* Link({ to, replace, ... }) → react-router Link with clean URLs. */
export function Link({ to, replace, className, children, style, onClick, ...rest }) {
  return (
    <RRLink
      to={to}
      replace={replace}
      className={className}
      style={style}
      onClick={onClick}
      {...rest}
    >
      {children}
    </RRLink>
  );
}

/* Pure pattern matcher kept for the few call sites that still use it. */
export function matchRoute(pattern, path) {
  const pp = pattern.split("/").filter(Boolean);
  const pa = path.split("/").filter(Boolean);
  if (pp.length !== pa.length) return null;
  const params = {};
  for (let i = 0; i < pp.length; i++) {
    if (pp[i].startsWith(":")) {
      params[pp[i].slice(1)] = decodeURIComponent(pa[i]);
    } else if (pp[i] !== pa[i]) {
      return null;
    }
  }
  return params;
}
